/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Step_VisitInputs */

const en_admin_funnel_step_visit = /** @type {(inputs: Admin_Funnel_Step_VisitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visitors`)
};

/**
* | output |
* | --- |
* | "Visitors" |
*
* @param {Admin_Funnel_Step_VisitInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_step_visit = /** @type {((inputs?: Admin_Funnel_Step_VisitInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Step_VisitInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_step_visit(inputs)
});
export { admin_funnel_step_visit as "admin.funnel.step.visit" }